<template>
  <div class="SingleEtablissement">
    <div>
      <span class="etablissement-nom">{{ etablissement.nom + " " }}</span>
      <span class="etablissement-infos"
        >{{ $t("registerPage.uai") }} {{ etablissement.codeEtablissement }}</span
      >
    </div>
    <div class="etablissement-infos">
      {{ `${etablissement.rue} ${etablissement.codePostal} ${etablissement.ville}` }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "SingleEtablissement",
  components: {},
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.SingleEtablissement {
  border: solid 1px $bookmarkcard-border-color;
  border-radius: 10px;
  padding: 0.5rem;
}
</style>
